import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "grid place-items-center min-h-screen max-h-full overflow-scroll" }
const _hoisted_2 = { class: "w-200 p-5" }
const _hoisted_3 = { class: "ml-xs mr-xl block" }

import { computed, watch } from "vue";

import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { useAccountStore } from "@/store/accountStore";
import { useSessionStore } from "@/store/sessionStore";
import ProfileCircle from "@/components/ProfileCircle.vue";
import ListTile from "@/components/ListTile.vue";
import RoundedCard from "@/components/RoundedCard.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectCareProviderGroupView',
  setup(__props) {

const accountStore = useAccountStore();
const sessionStore = useSessionStore();

const connectedCareProviderGroups = computed(
  () => accountStore.careProviderGroups
);

function selectCareProviderGroup(careProviderGroup: CareProviderGroup) {
  sessionStore.setSelectedCareProviderGroup(careProviderGroup);
}

// watch works directly on a ref
watch(accountStore, (olVal, newVal) => {
  if (
    newVal.careProviderGroups != null &&
    newVal.careProviderGroups.length === 1
  ) {
    selectCareProviderGroup(newVal.careProviderGroups[0].careProviderGroup);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(UmanaHeadline, {
        class: "pb-2",
        h: "h1"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Unternehmen")
        ]),
        _: 1
      }),
      _createVNode(RoundedCard, {
        "no-padding": true,
        class: "divide-y"
      }, {
        default: _withCtx(() => [
          (connectedCareProviderGroups.value == null)
            ? (_openBlock(), _createBlock(LoadingSpinner, {
                key: 0,
                class: "m-auto"
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(connectedCareProviderGroups.value, (careProviderGroup) => {
                return (_openBlock(), _createBlock(ListTile, {
                  key: careProviderGroup.care_provider_group_id,
                  onClick: ($event: any) => (selectCareProviderGroup(careProviderGroup.careProviderGroup)),
                  selected: true
                }, {
                  leading: _withCtx(() => [
                    _createVNode(ProfileCircle, {
                      "care-provider-group": careProviderGroup.careProviderGroup
                    }, null, 8, ["care-provider-group"])
                  ]),
                  main: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(careProviderGroup.careProviderGroup.group_name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})